<template>
  <div>
    <div
      v-for="child in menusOrdered"
      :key="child.id"
      class="color-custom-dark-grey"
    >
      <div v-if="child.isLeaf || hasValidChilds(child)">
        <div
          class="sidebar-menu-item d-flex flex-row justify-content-between align-items-center w-100 color-black"
          @click.prevent.stop="openClose(child)"
        >
          <div
            class="d-flex flex-row align-items-center"
            :class="firstLevel ? 'pl-2' : 'pl-4'"
          >
            <i
              v-if="!child.isLeaf"
              class="fa"
              :class="'fa-' + (childsOpen[child.id] ? 'folder-open' : 'folder')"
              aria-hidden="true"
              style="width:20px;"
            ></i>
            <span :class="!child.isLeaf ? 'ml-2' : ''">{{ child.name }} </span>
          </div>
          <i
            v-if="!child.isLeaf"
            class="pr-2 fa"
            :class="
              'fa-' + (childsOpen[child.id] ? 'chevron-up' : 'chevron-down')
            "
            aria-hidden="true"
          ></i>
        </div>
        <eoc-view-documents-sidebar
          v-if="childsOpen[child.id]"
          :menus="child.children"
          @add-tab="addTab"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DocumentList from "./document/DocumentList.vue";
import DocumentGroupList from "./document_group/DocumentGroupList.vue";

export default {
  name: "EocViewDocumentsSidebar",
  components: {},
  props: ["menus", "firstLevel"],
  data() {
    return {
      childsOpen: {}
    };
  },
  methods: {
    openClose(child) {
      if (!child.isLeaf) {
        if (this.childsOpen[child.id]) this.childsOpen[child.id] = false;
        else this.childsOpen[child.id] = true;
        this.childsOpen = { ...this.childsOpen };
      } else {
        const id = child.id;
        const type = id.startsWith("f") ? "Form" : "FormGroup";
        const objectId = id.substr(2);
        this.$emit("add-tab", {
          id: id,
          text: child.name,
          component: type == "Form" ? DocumentList : DocumentGroupList,
          elementData:
            type == "Form"
              ? {
                  formId: objectId
                }
              : {
                  formGroupId: objectId
                },
          category: "main"
        });
      }
    },
    addTab(data) {
      this.$emit("add-tab", data);
    },
    hasValidChilds(node) {
      for (let index = 0; index < node.children.length; index++) {
        const child = node.children[index];
        if (child.isLeaf) {
          return true;
        } else {
          const childResult = this.hasValidChilds(child);
          if (childResult) return true;
        }
      }
      return false;
    }
  },
  computed: {
    menusOrdered() {
      const menusOrdered = [...this.menus];
      return menusOrdered;
    }
  }
};
</script>

<style scoped>
.sidebar-menu-item {
  font-size: 14px;
  padding: 13px 15px;
}
.sidebar-menu-item:hover {
  cursor: pointer;
  background-color: white !important;
}
</style>
<style>
.vtl-operation {
  display: none !important;
}
.vtl-leaf-node:hover {
  cursor: pointer;
}
.vtl-tree-margin {
  margin-left: 1em !important;
}
.vtl-tree-margin {
  transition: all 2s linear;
}
.vtl-menu-icon {
  display: none;
}
.vtl-node-content,
.vtl-icon,
.vtl-icon:hover {
  color: #909db8;
}
.vtl-node-content {
  font-size: 0.9rem;
}
.vtl-node-main {
  padding: 7px 0px 7px 23px;
}
.vtl-tree-margin .vtl-node-main {
  padding-left: 35px;
}
.vtl-tree-margin {
  margin-left: 0 !important;
}
</style>
